/**
 * Enregistrement (une fois au démarrage) des créations offline-capable.
 *
 * Importé pour son effet de bord depuis App. Déclare les défauts de mutation
 * (mutationFn de rejeu + invalidation de liste) des 3 modules prioritaires et
 * démarre l'observateur de synchronisation différée. Périmètre v1 : création
 * (patients / rendez-vous / consultations). L'édition/suppression offline
 * viendra dans une itération suivante.
 */
import { appointmentsApi } from "@/features/appointments/api";
import { APPOINTMENTS_CREATE_KEY } from "@/features/appointments/hooks";
import { consultationsApi } from "@/features/consultations/api";
import { CONSULTATIONS_CREATE_KEY } from "@/features/consultations/hooks";
import { patientsApi } from "@/features/patients/api";
import { PATIENTS_CREATE_KEY } from "@/features/patients/hooks";
import { registerOfflineCreate, watchOfflineSync } from "@/lib/api/offline-mutations";
import { queryClient } from "@/lib/api/query-client";

registerOfflineCreate(queryClient, PATIENTS_CREATE_KEY, patientsApi.create, ["patients", "list"]);
registerOfflineCreate(queryClient, APPOINTMENTS_CREATE_KEY, appointmentsApi.create, ["appointments"]);
registerOfflineCreate(queryClient, CONSULTATIONS_CREATE_KEY, consultationsApi.create, [
  "consultations",
  "list",
]);

// Toast de synchro pour les écritures mises en file hors ligne, une fois envoyées.
watchOfflineSync(queryClient);
